import { connect } from 'react-redux'
import { clearPurchaseResultAction } from '../../actions/tapPayActions'
import PurchaseFailed from './PurchaseFailed'
import PurchaseSuccessPage from './PurchaseSuccessPage'

function PurchaseResult(props) {
  const { clearResult, purchaseResult, creamItemId } = props

  if (purchaseResult?.error) {
    return (
      <PurchaseFailed
        errno={purchaseResult.errno}
        onDone={clearResult}
        creamItemId={creamItemId}
      />
    )
  }

  return <PurchaseSuccessPage purchaseResult={purchaseResult} />
}

export default connect(null, dispatch => ({
  clearResult() {
    dispatch(clearPurchaseResultAction())
  },
}))(PurchaseResult)
